export default __webpack_public_path__ + "static/media/watchKlein.f81aec9c.jpg";